import { render, staticRenderFns } from "./cbc_basic.vue?vue&type=template&id=307d5d28&scoped=true"
import script from "./cbc_basic.vue?vue&type=script&lang=js"
export * from "./cbc_basic.vue?vue&type=script&lang=js"
import style0 from "./cbc_basic.vue?vue&type=style&index=0&id=307d5d28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "307d5d28",
  null
  
)

export default component.exports